import { render, staticRenderFns } from "./pelunasansettlefrm.vue?vue&type=template&id=3be4b00c&"
import script from "./pelunasansettlefrm.vue?vue&type=script&lang=js&"
export * from "./pelunasansettlefrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports